import { useEffect } from 'react';

function useHoverOutside(refs, onHoverOutside) {
  useEffect(() => {
    function handleMouseMove(event) {
      if (!refs.some(ref => ref.current && ref.current.contains(event.target))) {
        onHoverOutside();
      }
    }

    document.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [refs, onHoverOutside]);
}

export default useHoverOutside;